export default "__VITE_ASSET__CocSE4vY__"